import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function RishikeshLuxurycottages() {
    const heading = "Super Deluxe";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Rishikesh Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-rishikesh/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Super Deluxe",
            },
        ]
    }

    const roomBanner = {
        image: "/image/rishikesh-super-deluxe-room-detail.webp",
    };

    const roomQuote = {
        content: "Featuring a large window, the Super Deluxe Room invites you to soak in the fresh mountain air and peaceful surroundings. Whether you're enjoying your morning tea or unwinding in the evening, it's an ideal choice for couples and families seeking comfort with a scenic touch.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1 King",
        area: "26",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/rishikesh-super-deluxe-room-gallery-1.webp" },
        { image: "/image/rishikesh-super-deluxe-room-gallery-2.webp" },
        { image: "/image/rishikesh-super-deluxe-room-gallery-3.webp" },
        { image: "/image/rishikesh-super-deluxe-room-gallery-4.webp" },
        // { image: "/image/rishikesh-super-deluxe-room-gallery-5.webp" },
    ];

    const roomEquipment = {
        description: "Enjoy a peaceful stay in a comfortable room designed with practical facilities and thoughtful touches for added convenience.",
        equipment: [
        [
            "Premium Pocketed Spring Mattress",
            "Air Conditioning",
            "Complimentary High-Speed Wi-Fi",
            "Smart TV for Entertainment",
        ],
        [
            "Tea & Coffee Maker with Daily Replenishment",
            "Mini Bar for Refreshments",
            "Electronic In-Room Safe",
            "Writing Desk with Comfortable Chair",
        ],
        [
            "Hydropneumatic Shower with 24-Hour Hot Water",
            "Soft Cotton Linens and Plush Duvet",
            "Iron & Ironing Board",
            "Bathrobe & Slippers",
        ]
    ]
    };

    const roomBook = {
        location: "Rishikesh",
        title: "Super Deluxe",
        desc: "Experience a comfortable stay in Rishikesh with the Super Deluxe Room, designed to bring together modern amenities and peaceful surroundings. Step onto your private balcony, enjoy the fresh mountain air, and unwind in a spacious setting after a day of exploring.",
        details: [
            "1 King Size Bed",
            "Up to 3 Guests",
            "26 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#/home?propertyId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU=&JDRN=Y&RoomID=255031,255032,255033,255034,255035&ap=1&gsId=682NTPc7dd5tQYOO7KblEIVgpgsly1qSD956Ilzg2MDU="
    };


    const otherRoom = {
        slides: [

            {
                title: 'Suite',
                bg: '/image/rishikesh-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "33 sq.mt",
                ],
            },

            {
                title: 'Premium Suite',
                bg: '/image/rishikesh-premium-suite-inner.webp',
                slug: '/resort-de-coracao-rishikesh/premium-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "30 sq.mt",
                ],
            },

            {
                title: 'Ganga Suite',
                bg: '/image/rishikesh-ganga-suite-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/ganga-suite',
                details: [
                    "1 King Size Bed",
                    "Up to 3 Guests",
                    "30 sq.mt",
                ],
            },
            {
                title: 'Deluxe',
                bg: '/image/rishikesh-deluxe-inner-img.webp',
                slug: '/resort-de-coracao-rishikesh/deluxe',
                details: [
                    "1 King Size Bed",
                    "Up to 2 Guests",
                    "21 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-rishikesh/room-listing" }
    }

    return (
        <> 
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
